import * as React from 'react'
// libs
import { useQuery } from '@apollo/client/react'
import { useSelector } from 'react-redux'
import { formValueSelector } from 'redux-form'
// graphql
import { PLAN_TYPES_DETAILS_QUERY } from 'graphql/planType/queries'
// components
import CreatePlanForm from 'components/Modals/CreatePlanModal/Form/index'
// utils
import get from 'lodash/get'

const CreatePlanFormContainer: React.FC<any> = ({ form, ...props }) => {
  const planType = useSelector((state) => formValueSelector(form)(state, 'planType'))

  const { data: planTypeQuery } = useQuery(PLAN_TYPES_DETAILS_QUERY, {
    skip: !planType,
    fetchPolicy: 'network-only',
    variables: {
      filter: {
        ids: [planType?.value]
      }
    }
  })

  const fields = get(planTypeQuery, 'planTypes.data[0].fields', [])

  return <CreatePlanForm fields={fields} form={form} planType={planType} {...props} />
}

export default CreatePlanFormContainer
